import styles from "./VideoGallery.module.css";
import { useState } from "react";

// 1. Define the structure of a Video object
interface VideoArtwork {
  id: number;
  title: string;
  thumb?: string; // Optional because ID 2 is missing a thumb in your code
  videoSrc: string;
}

const VideoGallery = () => {
  const [activeVideo, setActiveVideo] = useState<VideoArtwork | null>(null);
  const artworkVideos = [
    {
      id: 1,
      title: "Charcoal Portait Demo",
      thumb: "thumb1.jpg",
      videoSrc: "/assets/imgs/gallery/charcoal_drawing_demo.mp4",
    },
    {
      id: 2,
      title: "Water color techniques demo",
      thumb: "thumb1.jpg",
      videoSrc: "/assets/imgs/gallery/water-color-thumb.mp4",
    },
    {
      id: 3,
      title: "Acrylic Painting Demo",
      thumb: "thumb3.jpg",
      videoSrc: "/assets/imgs/gallery/acrylic_video.mp4",
    },
    {
      id: 4,
      title: "Color Pencil Demo",
      thumb: "thumb4.jpg",
      videoSrc: "/assets/imgs/gallery/color-pencil-demo.mp4",
    },
  ];

  return (
    <section className={styles.videoSection}>
      <div className={styles.videoGrid}>
        {artworkVideos.map((video) => (
          <div
            key={video.id}
            className={styles.videoCard}
            onClick={() => setActiveVideo(video)}
          >
            <div className={styles.thumbContainer}>
              <video
                controls
                autoPlay
                playsInline /* Required for Safari/iOS */
                preload="auto"
                className={styles.videoPlayer}
                key={video.videoSrc}
              >
                <source src={video.videoSrc} type="video/mp4" />
                <p>Your browser does not support the video tag.</p>
              </video>
              <div className={styles.playButtonOverlay}>
                <div className={styles.playIcon}>▶</div>
              </div>
            </div>
            <p className={styles.videoLabel}>{video.title}</p>
          </div>
        ))}
      </div>
      {/* --- THE BIGGER WINDOW (MODAL) --- */}
      {activeVideo && (
        <div className={styles.videoModal} onClick={() => setActiveVideo(null)}>
          <div
            className={styles.modalContent}
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className={styles.closeBtn}
              onClick={() => setActiveVideo(null)}
            >
              &times;
            </button>

            <video
              controls
              autoPlay
              playsInline
              className={styles.videoPlayer}
              key={activeVideo.videoSrc} /* Resets the player for new videos */
            >
              <source src={activeVideo.videoSrc} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
            <h3 className={styles.modalTitle}>{activeVideo.title}</h3>
          </div>
        </div>
      )}
    </section>
  );
};

export default VideoGallery;
